import type React from "react";
import { useEffect, useRef } from "react";

/**
 * Forwarded refs may be a function or a ref object. This function will resolve the forwarded ref into a ref object.
 */
export default function useForwardedRef<E extends Element>(
  ref: React.ForwardedRef<E>,
) {
  const innerRef = useRef<E>(null);

  useEffect(() => {
    if (!ref) return;

    if (typeof ref === "function") {
      ref(innerRef.current);
    } else {
      ref.current = innerRef.current;
    }
  }, [ref]);

  return innerRef;
}
